<template>
  <label style="font-weight:normal">{{ currentValue }}</label>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
